import FileReplacePageContainer from './FileReplacePageContainer'
import FileReplacePage from './FileReplacePage'
export { FileReplacePage }
export { FileReplacePageContainer }
export default FileReplacePageContainer



// WEBPACK FOOTER //
// ./src/pages/FileReplacePage/index.js